// Shared helpers for every CSV the browser builds.
//
// A CSV cell that starts with = + - @ (or a tab / carriage return) is run as a FORMULA when the
// file is opened in Excel, Google Sheets or LibreOffice - for example =HYPERLINK(...) or
// =cmd|'/C calc'!A0. Cell values can originate in customer-uploaded files, so every cell goes
// through csvCell(): formula-looking text gets a leading apostrophe, which spreadsheets treat as
// "this is text". Plain numbers such as -12.5, 1,234.50, $5.00 or 50% are left alone because
// they cannot run as formulas and customers sum them.

const FORMULA_START = /^[\t\r ]*[=+\-@]/;
const TAB_OR_CR_START = /^[\t\r]/;   // always guarded, whatever follows
const PLAIN_NUMBER  = /^[+-]?\$?([0-9]+|[0-9]{1,3}(,[0-9]{3})+)(\.[0-9]+)?%?$/;

export function neutralizeFormula(value: unknown): string {
  const s = value === null || value === undefined ? '' : String(value);
  if (TAB_OR_CR_START.test(s) || (FORMULA_START.test(s) && !PLAIN_NUMBER.test(s.trim()))) return `'${s}`;
  return s;
}

/** One safely quoted CSV cell. */
export function csvCell(value: unknown): string {
  return `"${neutralizeFormula(value).replace(/"/g, '""')}"`;
}
